module.exports = __webpack_public_path__ + "static/img/07.254576a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/alpa_bern/07.jpg
// module id = 356
// module chunks = 1